module.exports = __webpack_public_path__ + "img/about01.dbc3468d.png";